import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography
} from '@mui/material';

// TODO: Replace with generated types once schema is updated
export enum GqlScoreType {
  RISK = 'RISK',
  WELLNESS = 'WELLNESS'
}

interface ScoreTypeSelectorProps {
  name: string;
  value?: GqlScoreType;
  onChange: (scoreType: GqlScoreType) => void;
  disabled?: boolean;
  label?: string;
  showDescription?: boolean;
}

const ScoreTypeSelector: React.FC<ScoreTypeSelectorProps> = ({
  name,
  value = GqlScoreType.RISK,
  onChange,
  disabled = false,
  label,
  showDescription = true
}) => {
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as GqlScoreType);
  };

  const scoreTypeOptions = [
    {
      value: GqlScoreType.RISK,
      label: t('Risk'),
      description: t('Risk assessment metric'),
      color: '#ff6b35'
    },
    {
      value: GqlScoreType.WELLNESS,
      label: t('Wellness'),
      description: t('Wellness indicator metric'),
      color: '#4caf50'
    }
  ];

  return (
    <FormControl component="fieldset" disabled={disabled} fullWidth>
      {label && (
        <FormLabel component="legend" sx={{ mb: 1 }}>
          {label}
        </FormLabel>
      )}
      <RadioGroup
        name={name}
        value={value}
        onChange={handleChange}
        row
      >
        {scoreTypeOptions.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={
              <Radio
                data-testid={`score-type-${option.value.toLowerCase()}`}
                sx={{
                  color: option.color,
                  '&.Mui-checked': {
                    color: option.color,
                  },
                }}
              />
            }
            label={
              <Box>
                <Typography variant="body2" fontWeight="medium">
                  {option.label}
                </Typography>
                {showDescription && (
                  <Typography variant="caption" color="text.secondary">
                    {option.description}
                  </Typography>
                )}
              </Box>
            }
            sx={{ 
              mr: 3,
              mb: showDescription ? 1 : 0,
              '& .MuiFormControlLabel-label': {
                ml: 0.5
              }
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default ScoreTypeSelector;